module.exports = __webpack_public_path__ + "static/media/contact-bg-people.15d9335d.png";